import React from "react"

// components
import { Typography, Button, message, Rate, Form, Input, Card } from "antd"

// configs
import config from "config"

// firebase
import { Firestore } from "services/firebase"
import { addDoc, collection, serverTimestamp } from "firebase/firestore"

// context
import { useTranslation } from "react-i18next"

const ReviewBox = () => {
  const { t } = useTranslation()

  const [messageApi, contextHolder] = message.useMessage()

  const [state, setState] = React.useState("idle")

  return state !== "review-sent" ? (
    <Card size="small">
      {contextHolder}

      <Typography.Paragraph>{t("review_intro")}</Typography.Paragraph>
      <Form
        layout="vertical"
        requiredMark={false}
        style={{ marginTop: 10 }}
        onFinish={async (values) => {
          try {
            setState("rate-order")

            await addDoc(collection(Firestore, "reviews"), {
              created_at: serverTimestamp(),
              resto_key: config.key,
              rate: values.rate,
              comment: values.comment || "",
            })

            setState("review-sent")
          } catch (e) {
            messageApi.error(e.message)
            console.error(e)
          }
        }}
      >
        <Form.Item
          label={t("rating")}
          name="rate"
          rules={[
            {
              required: true,
              message: t("please_rate_order"),
            },
          ]}
        >
          <Rate
            allowHalf
            style={{ fontSize: 20 }}
            count={5}
            tooltips={[
              t("very_bad"),
              t("bad"),
              t("okay"),
              t("good"),
              t("very_good"),
            ]}
          />
        </Form.Item>

        <Form.Item label={t("comment")} name="comment">
          <Input.TextArea
            placeholder={t("review_comment_placeholder")}
            style={{ minHeight: 100 }}
          />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={state === "rate-order" ? true : undefined}
          >
            {t("rate_btn")}
          </Button>
        </Form.Item>
      </Form>
    </Card>
  ) : (
    <Card size="small">
      {contextHolder}

      <Typography.Paragraph strong>
        {t("thank_you_review")}
      </Typography.Paragraph>
    </Card>
  )
}

export default ReviewBox
